module.exports = __webpack_public_path__ + "static/media/berimbau2018toque.47402f66.png";